import { render, staticRenderFns } from "./CallToAction.vue?vue&type=template&id=1dbc5576&scoped=true&"
import script from "./CallToAction.vue?vue&type=script&lang=ts&"
export * from "./CallToAction.vue?vue&type=script&lang=ts&"
import style0 from "./CallToAction.vue?vue&type=style&index=0&id=1dbc5576&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbc5576",
  null
  
)

export default component.exports